import React from 'react';

import { ButtonProps } from './Button.type';

export default function Button(props: ButtonProps) {
  return (
    <button
      disabled={props.isDisabled}
      onClick={props.onClick}
      className={
        !props.isDisabled
          ? 'w-full cursor-default bg-primary-green p-3 rounded-lg'
          : 'w-full cursor-pointer bg-gray-gray300 p-3 rounded-lg'
      }>
      <div
        className={
          !props.isDisabled
            ? 'bg-primary-green text-white laptop:text-extraLarge2 tablet:text-large mobile:text-regular text-center font-interMedium tracking-wide'
            : 'bg-gray-gray300 text-gray-gray500 laptop:text-extraLarge2 tablet:text-large mobile:text-regular text-center font-interMedium tracking-wide'
        }>
        {props.label}
      </div>
    </button>
  );
}
